import { EarlyAccessFeature } from "@doitintl/cmp-models";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, Stack, Typography } from "@mui/material";

import { CopyCodeBlock } from "../../../../Components/CopyCodeBlock/CopyCodeBlock";
import { useFeatureFlag } from "../../../../Components/hooks/useFeatureFlag";
import { useCustomerContext } from "../../../../Context/CustomerContext";
import mixpanel from "../../../../utils/mixpanel";
import {
  getCLICreateCommand,
  getCLIUpdateCommand,
} from "../../../Settings/AWS/ManagePermissions/FeaturesSelection/cloudFormationHelper";

interface AwsCliConnectionProps {
  featureKey: string;
  mixpanelFeatureId: string;
  roleToUpdate?: string;
}

const AwsCliConnection = ({ featureKey, mixpanelFeatureId, roleToUpdate }: AwsCliConnectionProps) => {
  const { customer } = useCustomerContext();
  const isFSK8SFeatureEnabled = useFeatureFlag(EarlyAccessFeature.FSK8S);

  const command = roleToUpdate
    ? getCLIUpdateCommand(customer.id, roleToUpdate, [featureKey], isFSK8SFeatureEnabled, "")
    : getCLICreateCommand(customer.id, [featureKey], isFSK8SFeatureEnabled, "");

  return (
    <Stack
      spacing={2}
      sx={{
        pt: 3,
      }}
      data-cy="clouddiagrams-cli-connection"
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 500,
        }}
        data-cy="clouddiagrams-cli-instructions"
      >
        Run the following command in AWS CloudShell
      </Typography>
      <Box data-testid="aws-cli-command" data-cy="clouddiagrams-cli-command">
        <Button
          variant="outlined"
          color="primary"
          startIcon={<OpenInNewIcon />}
          href="https://console.aws.amazon.com/cloudshell/home"
          target="_blank"
          onClick={() => {
            mixpanel.track(`${mixpanelFeatureId}.CLI-commands.set-up-${mixpanelFeatureId}-on-aws-console`);
          }}
          data-cy="clouddiagrams-open-aws-cloudshell"
        >
          Open AWS CloudShell
        </Button>
      </Box>
      <CopyCodeBlock base={command[0]} data-cy="clouddiagrams-cli-code-block" />
    </Stack>
  );
};

export default AwsCliConnection;
